import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import ShiftDigitalContainer from '../../Events/ShiftDigital/ShiftDigitalContainer';
import { SHIFT_DIGITAL_CORPORATE_CELL_LOCATION } from '@/js/services/ShiftDigital/ShiftDigitalConstants';
import SubaruFlexSpaceBanner from '../SubaruFlexSpaceBanner/SubaruFlexSpaceBanner.vue';
import { getAspectRatioHeight } from '../../../../js/services/CommonUtility';
import axios from 'axios';
export default {
  data() {
    return {
      imageDimensions: { width: '', height: '' },
      gallery: [],
      slickOptions: {
        dots: true,
        infinite: true,
        infiniteLoopOnEdge: true,
        groupsToShow: 3,
        groupsToScroll: 1,
        slidesPerGroup: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 1,
              dots: true,
              infinite: true,
              infiniteLoopOnEdge: true,
              arrows: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
              dots: true,
              infinite: true,
              infiniteLoopOnEdge: true,
              arrows: false,
            },
          },
          {
            breakpoint: 991,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
              dots: true,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
              dots: true,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 1,
              groupsToScroll: 1,
              dots: true,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: false,
            },
          },
        ],
      },
      isLandingPage: window.location.pathname === '/',
    };
  },
  components: {
    SubaruFlexSpaceBanner,
    VSlickCarousel,
  },
  methods: {
    onCorporateCellClick(item) {
      let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
      let location = SHIFT_DIGITAL_CORPORATE_CELL_LOCATION;
      // checking ==> if location available in a team
      if (item?.location) {
        location = item?.location;
      }
      if (shiftDigital?.linkClick) {
        shiftDigital.linkClick(location, item.linkType);
      }
      setTimeout(() => {
        if (item.path) {
          window.location.href = item.path;
        }
      }, 500);
    },
    async fetchGallery() {
      try {
        const url = `https://prod.cdn.secureoffersites.com/json/oem/subaru/corp-cell/SubaruCorporateCell.json?v=${this.getTimeStamp()}`;
        const response = await axios.get(url);
        this.gallery = response.data.map((item) => ({
          ...item,
          image: item.image,
        }));
      } catch (error) {
        console.error('Error fetching gallery data:', error);
      }
    },
    getTimeStamp() {
      return Math.floor(Date.now() / 1000);
    },
  },
  created() {
    let windowWidth = +window.innerWidth;
    if (windowWidth <= 700) {
      this.imageDimensions.width = +window.innerWidth;
      this.imageDimensions.height = getAspectRatioHeight(+window.innerWidth, 387, 210);
    }
  },
};
